module.exports = __webpack_public_path__ + "static/media/04-03.d1fccb5c.mp3";